import {
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";

import { useCallback, useContext, useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { ClubAPI } from "../../api/ClubAPI";
import { UserAPI } from "../../api/UserAPI";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { AuthContext } from "./AuthContext";
import Loader from "../../component/Loader";
import PopUpAlert from "../../component/PopUpAlert";
import playerImg from '../../assets/images/user.png';
import { AuthAPI } from "../../api/AuthAPI";
import { checkEmailAvailable, registrationConflictMessage } from "./emailVerification";
import EmailTakenHint from "./EmailTakenHint";
import ReCAPTCHA from "react-google-recaptcha";
import 'react-phone-input-2/lib/material.css';

const UserRegister = () => {
  const navigate = useNavigate();
  const { setIsLoading, isLoading } = useContext(AuthContext);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [registerData, setRegisterData] = useState({});
  const [passNotMatch, setPassNotMatch] = useState(false);
  const [message, setMessage] = useState({ type: '', content: '' });
  //const [dateOfBirth, setDateOfBirth] = useState("");
  //const [phone, setPhone] = useState('+1');
  //const [isPhoneInputFocused, setIsPhoneInputFocused] = useState(false);
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    //phone: false,
    password: false,
    confirmPassword: false,
    //dateOfBirth: false,
    //address: false,
    club: false,
    passwordValidateError: false
  });
  const [passwordValidate, setPasswordValidate] = useState({ length: false, specialSymbal: false, allowedChars:false, number: false, upperLetter: false, lowerLetter:false })
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [clubsList, setClubsList] = useState([]);
  const [club, setClub] = useState("");

  const handleClickShowPassword = () => setShowPassword1((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowPassword2((show) => !show);

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };
  const handleAutocomplete = async (event) => {
    if (!event.target.value?.trim()) {
      setClubsList("");
      setClub("");
      return;
    }

    const clubName = {
      clubName: event.target.value?.trim()
    }
    if (clubName?.clubName?.length < 3) return;
    const response = await ClubAPI.fetchAllClubs(clubName)
    const clubArray = []
    response?.Data?.forEach(item => {
      clubArray.push({ label: item.clubName, id: item.clubId })
    })
    setClubsList(clubArray)
  };
  const optimizedSearch = useCallback(debounce(handleAutocomplete), []);

  const applyEmailCheck = async (email) => {
    try {
      const result = await checkEmailAvailable(email, UserAPI.emailExists);
      if (!result.ok) {
        setErrors((prev) => ({ ...prev, email: result.message }));
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      return true;
    }
  };

  const handleRegisterData = (event) => {
    setErrors({});
    setPassNotMatch(false);
    const { name, value } = event.target;
   
    const uppercasePattern = /[A-Z]/;
    const lowercasePattern = /[a-z]/;
    const numberPattern    = /[0-9]/;
    // Exactly one of ! @ $ *
    const specialCharPattern = /[!@$*]/; 
    const allowedCharsPattern = /^[A-Za-z0-9!@$*]+$/;
    if (name === 'password') {
      let template = {}
      if (uppercasePattern.test(value)) {
        template.upperLetter = true;
      }
      if (lowercasePattern.test(value)) {
        template.lowerLetter = true;
      }
      if (specialCharPattern.test(value)) {
        template.specialSymbal = true;
      }
      if (allowedCharsPattern.test(value)) {
        template.allowedChars = true;
      }
      if (numberPattern.test(value)) {
        template.number = true;
      }
      if (value?.length >= 8 && value?.length <= 20) {
        template.length = true;
      }
      setPasswordValidate(template);
    }
    let newVal;
    if (name === 'phone' && !value.startsWith('1')) {
      newVal = '1' + value
    } else {
      newVal = value;
    }
    setRegisterData({ ...registerData, [name]: newVal });
  };
  const submitRegisterData = async (event) => {
    setMessage({ type: '', content: '' });
    try {
      event.preventDefault();
      let errorFields = {};
      if (!registerData.firstName?.trim()) {
        errorFields.firstName = true;
      }
      if (!registerData.lastName?.trim()) {
        errorFields.lastName = true;
      }
      if (!registerData.email?.trim()) {
        errorFields.email = true;
      }
      // if (!registerData.phone.trim()) {
      //   errorFields.phone = true;
      // }
      // if (registerData.phone.trim().length < 3) {
      //   errorFields.phone = true;
      // }
      // if (!dateOfBirth) {
      //   errorFields.dateOfBirth = true;
      // }
      if (!registerData.password?.trim()) {
        errorFields.password = true;
      }
      if (!registerData.confirmPassword?.trim()) {
        errorFields.confirmPassword = true;
      }
      // if (!registerData.address?.trim()) {
      //   errorFields.address = true;
      // }
      if (!passwordValidate.length || !passwordValidate.upperLetter || 
        !passwordValidate.allowedChars || !passwordValidate.lowerLetter ||
        !passwordValidate.number || !passwordValidate.specialSymbal) {
        errorFields.passwordValidateError = true;
      }
      if (!club) {
        errorFields.club = true;
      }

      setErrors(errorFields);
      if (
        !registerData.firstName?.trim() ||
        !registerData.lastName?.trim() ||
        !registerData.email?.trim() ||
        //!registerData.phone?.trim() ||
       // registerData.phone?.trim().length < 3 ||
        //!dateOfBirth ||
        //!registerData.address?.trim() ||
        !registerData.confirmPassword?.trim() ||
        !registerData.password?.trim() ||
        !club
      ) {
        return;
      }
      if (!passwordValidate.length || !passwordValidate.upperLetter || 
        !passwordValidate.allowedChars || !passwordValidate.lowerLetter ||
        !passwordValidate.number || !passwordValidate.specialSymbal) {
        return;
      }
      if (registerData.password !== registerData.confirmPassword) {
        setPassNotMatch(true);
        return;
      }
      if (!(await applyEmailCheck(registerData.email))) {
        return;
      }

      const registrationData = {
        email: registerData.email,
        password: registerData.password,
       // address: registerData.address,
       //dob: dateOfBirth,
       // mobile: "+" + registerData.phone,
        firstName: registerData.firstName,
        lastName: registerData.lastName,
        isClubOwner: false,
        isCoach: false,
        isGuardian: false,
        isGuest: false,
        isPlayer: true,
        club: { clubName: club.label.trim(), clubId: club.id.trim() },
        pathName: window.location.pathname
      };

      setIsLoading(true);
      await UserAPI.registerUser(registrationData);
      setIsLoading(false);
      navigate("/email-sent", {
        replace: true,
        state: { userName: registerData.email, registerFor: 'player' },
      });
    } catch (err) {
      setIsLoading(false);
      console.error(err);
      const conflict = registrationConflictMessage(err);
      if (conflict) {
        setErrors((prev) => ({ ...prev, email: conflict }));
        setMessage({ type: 'error', content: conflict });
        return;
      }
      setMessage({ type: 'error', content: err?.response?.data?.Message || err?.response?.data?.Data });
    }
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const verifyCaptcha = async (data) => {

    try {
      const response = await AuthAPI.postVerifyCaptcha(data);
      setCaptchaVerified(response.Data);
    } catch (error) {

    }
  }


  return (
    <div className="player_register_container" onSubmit={submitRegisterData}>
      {isLoading && <Loader />}
      <PopUpAlert type={message.type} message={message.content} />
      <form className="player_register_container_body">
        <div className="player_heading">
          <img src={playerImg} alt="" />
          <h2>User Registration</h2>
        </div>
        <div className="player_name">
          <TextField
            inputProps={{ maxLength: 100 }}
            error={errors.firstName}
            helperText={errors.firstName && "First Name is required"}
            value={registerData.firstName || ""}
            onChange={handleRegisterData}
            name="firstName"
            className="player-reg-text-input"
            sx={{ width: "49%", "@media (max-width:400px)": { width: "100%" } }}
            label="First Name"
            variant="outlined"
          />

          <TextField
            inputProps={{ maxLength: 100 }}
            error={errors.lastName}
            helperText={errors.lastName && "Last Name is required"}
            value={registerData.lastName || ""}
            onChange={handleRegisterData}
            name="lastName"
            className="player-reg-text-input"
            sx={{ width: "49%", "@media (max-width:400px)": { width: "100%" } }}
            label="Last Name"
            variant="outlined"
          />
        </div>
        <TextField
          inputProps={{ maxLength: 100 }}
          error={Boolean(errors.email)}
          helperText={errors.email === true ? "Email is required" : errors.email ? <EmailTakenHint message={errors.email} /> : null}
          value={registerData.email || ""}
          onChange={handleRegisterData}
          onBlur={() => registerData.email && applyEmailCheck(registerData.email)}
          name="email"
          className="player-reg-text-input"
          type="email"
          label="Email"
          variant="outlined"
        />
        {/* <PhoneInput
          country={'us'}
          containerStyle={isPhoneInputFocused ?
            errors.phone ?
              {
                color: '#d32f2f'
              }
              :
              { color: 'var(--hoverColorBold)' }
            :
            errors.phone ?
              {
                color: '#d32f2f'
              } : { color: 'black' }}
          inputStyle={isPhoneInputFocused ?
            errors.phone ?
              {
                border: '1px solid #d32f2f',
                boxShadow: 'none',
                width: '100%',
                color: '#d32f2f',
                borderRadius: '10px',
              } :
              {
                border: '2px solid var(--hoverColorBold)',
                boxShadow: 'none',
                transition: '.2s ease',
                borderRadius: '10px',
                width: '100%'
              } : errors.phone ?
              {
                border: '1px solid #d32f2f',
                boxShadow: 'none',
                width: '100%',
                color: '#d32f2f',
                borderRadius: '10px',
              } : { borderRadius: '10px', width: '100%' }}
          disableDropdown={true}
          value={registerData.phone||''}
          onFocus={() => setIsPhoneInputFocused(true)}
          onBlur={() => setIsPhoneInputFocused(false)}
          onChange={(e) => handleRegisterData({ target: { name: 'phone', value: e } })}
        /> */}
        {/* {errors.phone && <div className="phone-number-input-error-msg">{"Phone is required"}</div>}
        */}
        <Autocomplete
          fullWidth
          value={club || ""}
          onChange={(event, newValue) => setClub(newValue)}
          name="club"
          disableClearable={true}
          options={clubsList || []}
          renderInput={(params) => (
            <TextField
              className="signup-text-input "
              {...params}
              value={club || ""}
              error={errors.club}
              placeholder="Type the first 3 characters of the club name"
              helperText={errors.club && "Please Select Club"}
              onChange={optimizedSearch}
              label="Club — type the first 3 characters of the club name"
            />
          )}
        />

        <FormControl
          fullWidth
          error={errors.password || passNotMatch || errors.passwordValidateError}
          className="signup-text-input"
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Password
          </InputLabel>
          <OutlinedInput
            value={registerData.password || ""}
            onChange={handleRegisterData}
            name="password"
            sx={{ borderRadius: 2 }}
            id="outlined-adornment-password"
            type={showPassword1 ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword1 ? <MdVisibilityOff /> : <MdVisibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
          {passNotMatch && (
            <FormHelperText sx={{ color: "red" }}>
              {"Password not matching"}
            </FormHelperText>
          )}
          {errors.password && (
            <FormHelperText sx={{ color: "red" }}>
              {"Password is required"}
            </FormHelperText>
          )}
          {errors.passwordValidateError && (
            <FormHelperText sx={{ color: "red" }}>
              {"please give a valid password"}
            </FormHelperText>
          )}
        </FormControl>
        <div className="password_validate_message_box">
        <p className={passwordValidate.upperLetter ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 Uppercase.
                </p>
                <p className={passwordValidate.lowerLetter ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 lowercase.
                </p>
                <p className={passwordValidate.specialSymbal ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Must include exactly one of: ! @ $ * (no other special characters).
                </p>
                <p className={passwordValidate.allowedChars ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    No other characters allowed.
                </p>
                <p className={passwordValidate.number ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 Number.
                </p>
                <p className={passwordValidate.length ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Minimum 8 and Maximum 20 characters.
                </p>
        </div>
        <FormControl
          fullWidth
          className="signup-text-input"
          error={errors.confirmPassword || passNotMatch || errors.passwordValidateError}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password2">
            Confirm Password
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: 2 }}
            value={registerData.confirmPassword || ""}
            onChange={handleRegisterData}
            name="confirmPassword"
            id="outlined-adornment-password2"
            type={showPassword2 ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword2 ? <MdVisibilityOff /> : <MdVisibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Confirm Password"
          />
          {errors.confirmPassword && (
            <FormHelperText sx={{ color: "red" }}>
              {"Confirm Password is required"}
            </FormHelperText>
          )}
          {passNotMatch && (
            <FormHelperText sx={{ color: "red" }}>
              {"Password not matching"}
            </FormHelperText>
          )}
        </FormControl>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            className="date_picker"
            onChange={(e) => setDateOfBirth(e)}
            label="Date of Birth"
            slotProps={
              errors.dateOfBirth && {
                textField: {
                  color: "secondary",
                  error: "true",
                  helperText: "Select your date of birth",
                },
              }
            }
            sx={{ width: "100%" }}
          />
        </LocalizationProvider> */}
        {/* <CustomPlaceAutocomplete
          onChange={(val) => {
            handleRegisterData({ target: { name: 'address', value: val } })
          }}
          error={errors.address}
          helperText={errors.address && "Address in required"}
          value={registerData?.address || ''}
          variant="outlined"
          label="Address" /> */}
        <ReCAPTCHA
          style={{ marginTop: '20px' }}
          sitekey={import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}
          onChange={(data) => verifyCaptcha(data)}
        />
        <div className="player_reg_btn">
          <Button disabled={!captchaVerified} type="submit" variant="contained">
            Register
          </Button>
        </div>
        <div className="player_privacy_policy">
          <p>By signing up, you agree to the Sportmingle <Link to={'https://sportmingle.com/terms_and_conditions.html'}>Term of Services</Link> and <Link to={'https://sportmingle.com/privacy_policy.html'}>Privacy Policy</Link></p>
        </div>
        <div className="redirect_to_sign_in">
          Already have an account?<Link to={'/login'}>Sign in</Link>
        </div>
      </form>
    </div>
  );
};

export default UserRegister;